<template>
  <div class="fondo-color">
    <v-form ref="form" v-model="valid" lazy-validation style="max-width: 70rem;
    width: 100%;
    margin: auto;max-width: 50rem;">
      <v-card-text>
        <v-container>
          <v-card elevation="7" style="padding: .5rem;">
            <v-card-title>
              <span class="text-title-responsive" style="color: rgb(0 108 187); font-weight: 600;">Inscripción a la
                Escuela de Cuidadores del Paciente en Diálisis - EsSalud</span>
            </v-card-title>
          </v-card>
          <v-card elevation="7" style="padding:3rem 2rem; margin-top: 1rem;">
            <h4 style="color: rgb(0 108 187);">Datos del paciente</h4>
            <v-divider style="margin-bottom: 2rem;"></v-divider>
            <v-row>
              <!-- <span>Para registrarse en el curso ingrese al siguiente
                <a href="https://renasalud.essalud.gob.pe/login/index.php">link</a>. Seleccionar la opción de "Crear
                nueva cuenta".</span> -->
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.num_docPaciente" label="Ingrese DNI del paciente*"
                  :maxlength="maxdat" @keyup.enter="loadPaciente" @keydown.tab.prevent="handleTabKey" required
                  :rules="[(v) => !!v || 'Este campo es obligatorio', numeroRules]"></v-text-field>
                <v-btn @click="loadPaciente">Buscar</v-btn>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.nombre" label="Nombres y apellidos" :maxlength="maxdat"
                  disabled></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete v-model="dataSolicitud.ipress" :items="itemsIpress" dense item-text="descripCas"
                  item-value="url" label="Clínica/CNSR" :maxlength="90" disabled></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete v-model="dataSolicitud.distrito" :items="itemsDistrito" dense item-text="distrito"
                  item-value="url" label="Distrito actual" :maxlength="90" disabled></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.telefono" label="Teléfono" :maxlength="maxdat"
                  :disabled="statusTelefono"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.telefono_paciente" label="Añadir otro teléfono"
                  :maxlength="maxdatNueve"></v-text-field>
              </v-col>
            </v-row>

            </v-card>
          <v-card elevation="7" style="padding:3rem 2rem;margin-top: 1rem;">
            <h4 style="    color: rgb(0 108 187);">Registro del participante</h4>
            <v-divider style="margin-bottom: 2rem;"></v-divider>

            <!-- <v-row> -->
            <!--  <v-col cols="12" sm="12" md="12" class="d-flex">
                    <v-checkbox
                      v-model="titularSi"
                      :label="`Sí`"
                      style="margin-right: 1rem;"
                      @click="updateEstado('titularSi')"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="titularNo"
                      :label="`No`"
                      @click="updateEstado('titularNo')"
                    ></v-checkbox>
                </v-col> -->
            <!--  <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.documento_cuidador" label="DNI*" :maxlength="maxdatNueve"
                  @input="onlyNumber('documento_cuidador', $event)" ref="dniCuidador" :rules="[numeroRules, dniRules]"
                  required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.nombre_cuidador" label="Nombres y apellidos*" :maxlength="maxdat"
                  :rules="[nombreRules]" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.correo_cuidador" label="Correo*" type="email" :rules="[emailRules]"
                  :maxlength="maxdat" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.telefono_cuidador" label="Teléfono*" :rules="[numeroRules]"
                  :maxlength="maxdatNueve" @input="onlyNumber('telefono_cuidador')" required></v-text-field>
              </v-col>
            </v-row>
            <br> -->
            <v-row>
              <!-- <v-col cols="12" sm="12" md="12">
                <v-card style="padding: 1rem;">
                  <h4 style="color: rgb(0 108 187);">Nota: La información será contrastada antes de realizar la
                    inscripción.
                    <br>
                    <div style="padding-left: 2.29rem;">Si el participante es el mismo paciente debe llenar los campos
                      en
                      las dos secciones.</div>
                  </h4>
                </v-card>
              </v-col>
              <v-card-actions style="margin-top: 1rem;">
                <v-spacer></v-spacer>
                <v-btn text color="#1973a5" outlined @click="validarCampos" v-if="!statusFormEdit"> Registrarse </v-btn>
                <v-btn text @click="validarCampos" v-if="statusFormEdit"> Editar </v-btn>
              </v-card-actions> -->
            </v-row>
          </v-card>
        </v-container>
      </v-card-text>
    </v-form>
    <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
      <v-card color="#1973a5" dark>
        <v-card-text>
          Cargando Datos
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<style>
.swal2-shown.swal2-height-auto {
  padding: 0 !important;
}

.fondo-color {
  background: linear-gradient(135deg,
      rgb(25, 115, 165),
      rgb(20, 145, 215),
      #0d67aa,
      #00304e) !important;
}

.custom-swal-modal {
  width: 90%;
  /* Ajusta el ancho según tus necesidades */
  max-width: 400px;
  /* Ajusta el ancho máximo según tus necesidades */
}

.text-title-responsive {
  font-size: 1.7rem !important;
}

/* Estilos específicos para dispositivos móviles */
@media (max-width: 600px) {
  .custom-swal-modal {
    width: 70%;
    /* Ajusta el ancho según tus necesidades para dispositivos móviles */
    max-width: 250px;
    /* Ajusta el ancho máximo según tus necesidades para dispositivos móviles */
  }
}

@media (max-width: 768px) {

  /* Puedes ajustar el tamaño máximo según tus necesidades */
  .mobile-error-modal {
    font-size: 14px;
    /* Tamaño de fuente más pequeño para el modal en móviles */
  }

  .mobile-error-icon {
    font-size: 10px !important;
    /* Tamaño de icono más pequeño para móviles */
  }

  .text-title-responsive {
    font-size: 1.1rem !important;
    line-height: 1.5;
  }
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import "jspdf-autotable";
import Swal from "sweetalert2";
import jsPDF from "jspdf";

export default {
  props: ['itemsSend'],
  data: () => ({
    maxdatNueve: 9,
    statusFormEdit: false,
    dialogLoader: false,
    //Perfil Usuario
    perfil: "",
    nombre: "",
    url: "",
    usuario: "",
    //Distritos
    itemsDistrito: [],
    //IPRESS
    itemsIpress: [],
    //Paciente
    dataPaciente: [],
    //Datos Formulario
    dataSolicitud: {
      paciente_id: null,
      num_docPaciente: null,
      nombre: null,
      ipress: null,
      distrito: null,
      telefono: null,
      telefono_cuidador: null,
      telefono_paciente: null,
      documento_cuidador: null,
      nombre_cuidador: null,
      correo_cuidador: null,
      certificado: false,
      cuidador_estado: false,
      fecha_registro: new Date().toLocaleDateString('sv-SE') + " " + new Date().toLocaleTimeString('sv-SE', { hour12: false }),
      dominioActual: null
    },
    //Formulario Parámetros
    titularSi: true,
    titularNo: false,
    valid: true,
    maxdatDocumento: 20,
    maxdat: 50,
    stateOtro: false,
    statusOtroParentesco: false,
    statusCertificado: false,
    rules: {
      required: (value) => !!value || "Campo Obligatorio.",
      counter: (value) => value <= 20 || "Max 20 characters",
    },
    statusTelefono: true,
    numeroCuidadores: 0,
    nombreRules: (v) => !!v || "Campo Obligatorio.",
    dniRules: (v) => !!v || "Campo Obligatorio.",
    emailRules: v => /.+@.+\..+/.test(v) || 'E-mail debe contener un @',
    numeroRules:
      v => /^[0-9]*$/.test(v) || 'El campo solo debe contener números',
  }),

  computed: {},
  watch: {
    titularSi(newValue) {
      // Si titularSi está marcado como "Sí", deselecciona titularNo
      if (newValue) {
        this.titularNo = false;
      }
    },
    titularNo(newValue) {
      // Si titularNo está marcado como "No", deselecciona titularSi
      if (newValue) {
        this.titularSi = false;
      }
    }
  },
  methods: {
    handleTabKey(event) {
      if (event.keyCode === 9) { // Verifica si la tecla presionada es Tab (código 9)
        this.loadPaciente();
      }
    },
    /* onlyNumber(event) {
      console.log("se esta ejecutando esto ")
      // Solo permite números
      let value = event.target.value;
      value = value.replace(/\D/g, ''); // Elimina cualquier cosa que no sea dígito
      event.target.value = value;
      this.$emit('input', value);
    }, */
    onlyNumber(field, event) {
      /* let value = event.target.value;
      value = value.replace(/\D/g, '');  */// Elimina cualquier cosa que no sea dígito
      /* this.dataSolicitud[field] = value; */
      const letters = this.dataSolicitud[field].replace(/[0-9]/g, ''); // Elimina todos los números, dejando solo las letras
      const numbers = this.dataSolicitud[field].replace(/\D/g, '');
      this.dataSolicitud[field] = numbers;
      console.log("numbers", numbers)
    },
    updateEstado(selectedCheckbox) {
      if (selectedCheckbox === 'titularSi' && !this.titularSi) {
        this.titularNo = true;
      } else if (selectedCheckbox === 'titularNo' && !this.titularNo) {
        this.titularSi = true;
      }
    },
    validarCampos() {
      if (this.$refs.form.validate() === false) {
        Swal.fire({
          title: "Error!",
          text: "¡Los datos ingresados no son válidos!",
          icon: "error",
          confirmButtonText: "Aceptar",
          customClass: {
            popup: 'custom-swal-modal',
            icon: 'mobile-error-icon'
          }
        });
        return;
      }
      this.dialogLoader = true;
      if (this.dataSolicitud.num_docPaciente == null) {
        Swal.fire({
          title: "Error!",
          text: "¡Debe completar todos los campos obligatorios! (*)",
          icon: "error",
          confirmButtonText: "Aceptar",
          customClass: {
            popup: 'custom-swal-modal',
            icon: 'mobile-error-icon'
          }
        });
        this.dialogLoader = false;
        return;
      };
      console.log("data solicitud", this.dataSolicitud.documento_cuidador);
      if (this.dataSolicitud.documento_cuidador == null || this.dataSolicitud.documento_cuidador == "" || this.dataSolicitud.nombre_cuidador == null || this.dataSolicitud.nombre_cuidador == "" || this.dataSolicitud.correo_cuidador == null || this.dataSolicitud.correo_cuidador == "" || this.dataSolicitud.telefono_cuidador == null || this.dataSolicitud.telefono_cuidador == "") {
        Swal.fire({
          title: "Error!",
          text: "¡Debe completar todos los campos obligatorios! (*)",
          icon: "error",
          confirmButtonText: "Aceptar",
          customClass: {
            popup: 'custom-swal-modal',
            icon: 'mobile-error-icon'
          }
        });
        this.dialogLoader = false;
      } else {
        console.log("data solicitud1111111", this.dataSolicitud.documento_cuidador);
        this.grabar();
      };
    },
    grabar() {
      this.dialogLoader = true;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/formularioCapacitacion/",
              this.dataSolicitud,
              {
                headers: { Authorization: this.auth },
              })
            .then((res) => {
              this.dialogLoader = false;
              Swal.fire({
                title: "¡Éxito!",
                text: "Se registró con éxito su solicitud de inscripción al curso, una vez que se haya validado, se le enviarán las credenciales de acceso a la plataforma al correo registrado.",
                icon: "success",
                showConfirmButton: true,
                confirmButtonText: "Aceptar",
                allowOutsideClick: false, // Evita que se cierre al hacer clic fuera del mensaje
                customClass: {
                  popup: 'custom-swal-modal',
                  icon: 'mobile-error-icon'
                }
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.reload();
                }
              });
            })
            .catch((res) => {
              console.log("Error:", res);
              this.dialogLoader = false;
              Swal.fire({
                title: "¡Error!",
                text: "¡No registró correctamente!",
                icon: "error",
                confirmButtonText: "Aceptar",
                customClass: {
                  popup: 'custom-swal-modal',
                  icon: 'mobile-error-icon'
                }
              });
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    loadIpress() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/cas/", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.itemsIpress = res.data.filter(item => item.estado === true);
              const baseUrl = new URL(res.data[0].url).origin + "/";
              this.dataSolicitud.dominioActual = baseUrl;
              this.loadDistritos();
            })
            .catch((res) => {
              console.log("Error:", res);
              this.dialog = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    loadDistritos() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/cas/", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              const dataDistrito = res.data.filter(item => item.estado === true);
              /* this.itemsDistrito = dataDistrito.filter(item => item.distrito !== "1"); */
              this.itemsDistrito = dataDistrito
                .filter(item => item.estado == true && item.tipoCas !== "1")
                .sort((a, b) => a.distrito.localeCompare(b.distrito));

              // Suponiendo que tu array original se llama 'data'
              let distritosUnicos = [];
              let distritosYaVistos = {};

              for (let i = 0; i < this.itemsDistrito.length; i++) {
                let distrito = this.itemsDistrito[i].distrito;
                if (!distritosYaVistos[distrito]) {
                  distritosUnicos.push(this.itemsDistrito[i]);
                  distritosYaVistos[distrito] = true;
                }
              }
              this.itemsDistrito = distritosUnicos;
              this.itemsDistrito1 = distritosUnicos;
              this.itemsDistrito2 = distritosUnicos;
              console.log("se lista los distritos en su totatl", this.itemsDistrito);
              if (this.usuario && this.itemsSend) {
                this.editCreate();
                this.statusFormEdit = true;
              }
            })
            .catch((res) => {
              this.dialog = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    updateCampoDNI() {
      this.$nextTick(() => {
        this.$refs.dniCuidador.$el.querySelector('input').focus();
      });
    },
    loadPaciente() {
      this.loadIpress();
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/generar_busqueda_pacientes/", { dni: this.dataSolicitud.num_docPaciente }, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {

              this.dataPaciente = res.data;
              if (this.dataPaciente[0]) {
                this.dataSolicitud.paciente_id = this.dataSolicitud.dominioActual + "paciente" + "/" + this.dataPaciente[0].id_paciente + "/";
                this.dataSolicitud.nombre = this.dataPaciente[0].nombre_paciente;

                this.dataSolicitud.ipress = this.dataPaciente[0].clinica;
                this.dataSolicitud.distrito = this.dataPaciente[0].distrito;
                /* if (!this.dataPaciente[0].telefono && this.dataPaciente[0].datosPaciente.telefono_paciente) {
                  this.dataSolicitud.telefono = this.dataPaciente[0].datosPaciente.telefono_paciente;
                  this.dataSolicitud.telefono_paciente = this.dataPaciente[0].datosPaciente.telefono;
                } else {
                  this.dataSolicitud.telefono = this.dataPaciente[0].datosPaciente.telefono;
                  this.dataSolicitud.telefono_paciente = this.dataPaciente[0].datosPaciente.telefono_paciente;
                } */
                /* this.statusTelefono = this.dataPaciente[0].datosPaciente.telefono == null ? false : true; */
                /* this.loadCuidadores(this.dataPaciente[0].datosPaciente.url); */
                this.updateCampoDNI();
              } else {
                this.dataSolicitud.paciente_id = "";
                this.dataSolicitud.nombre = "";
                this.dataSolicitud.ipress = "";
                this.dataSolicitud.distrito = "";
                this.dataSolicitud.telefono = "";
                this.dataSolicitud.telefono_paciente = "";
                this.numeroCuidadores = 0;
                Swal.fire({
                  title: "¡Error!",
                  text: "¡El DNI ingresado no es de un paciente que se encuentra adscrito en el Centro Nacional de Salud Renal!",
                  icon: "error",
                  confirmButtonText: "Aceptar",
                  customClass: {
                    popup: 'custom-swal-modal',
                    icon: 'mobile-error-icon'
                  }
                });
              }
            })
            .catch((res) => {
              console.log("Error:", res);
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    loadCuidadores(idPaciente) {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/generar_calculo_numero_cuidadores/", { paciente: idPaciente.split("/")[4] }, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.numeroCuidadores = res.data[0].n;

            })
            .catch((res) => {
              this.dialog = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    }
  },

  mounted() {
  },
  created() {
    this.loadIpress();
    this.usuario = sessionStorage.getItem("usuario");
  },
};
</script>